(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orjn-archive-campaign"]) return;
  try {
    
const archiveEvents = import('@theme/events').catch(() => null);
function archiveCloseQuickAdd(quickAdd,restoreFocus=false){
  const panel=quickAdd.querySelector('[data-orjn-qa-panel]'),trigger=quickAdd.querySelector('[data-orjn-qa-trigger]');
  if(panel){if(typeof panel.hidePopover==='function'&&panel.matches(':popover-open'))panel.hidePopover();panel.hidden=true;panel.removeAttribute('popover');}
  quickAdd.classList.remove('is-open','is-archive-open');quickAdd.closest('.product-card')?.classList.remove('is-qa-active');
  trigger?.setAttribute('aria-expanded','false');
  if(restoreFocus)trigger?.focus({preventScroll:true});
}
function archivePlaceQuickAdd(quickAdd){
  const panel=quickAdd.querySelector('[data-orjn-qa-panel]'),trigger=quickAdd.querySelector('[data-orjn-qa-trigger]');
  const anchor=trigger.getBoundingClientRect(),viewport=window.visualViewport;
  const top=viewport?.offsetTop||0,leftEdge=viewport?.offsetLeft||0;
  const width=viewport?.width||innerWidth,height=viewport?.height||innerHeight;
  const rect=panel.getBoundingClientRect(),below=anchor.bottom+8;
  const left=Math.max(leftEdge+12,Math.min(anchor.right-rect.width,leftEdge+width-rect.width-12));
  const y=below+rect.height<=top+height-12?below:Math.max(top+12,Math.min(anchor.top-rect.height-8,top+height-rect.height-12));
  panel.style.setProperty('--qa-left',left+'px');panel.style.setProperty('--qa-top',y+'px');
}
function archiveNativeSizes(root=document) {
  root.querySelectorAll('.orjn-archive__normal-card').forEach(card=>{
    const variants=card.querySelector('[data-archive-variants]').content;
    const selected=card.querySelector('[data-archive-link]').href;
    card.querySelectorAll('.product-card__link,.orjn-card-qa__view-link').forEach(link=>{link.href=selected;link.setAttribute('data-archive-link','');});
    card.querySelectorAll('[data-orjn-qa-size]').forEach(button=>{
      if(button.dataset.archiveReady)return;
      const variant=variants.querySelector(`[data-variant-id="${button.dataset.variantId}"]`);
      if(!variant)return;
      const size=document.createElement('span');size.textContent=button.textContent.trim();
      const price=document.createElement('span');price.className='orjn-card-qa__size-price';price.textContent=variant.dataset.price;
      button.replaceChildren(size,price);
      button.setAttribute('aria-label',`Add EU ${variant.dataset.size} at ${variant.dataset.price} to cart`);
      button.dataset.archiveReady='true';
    });
    const trigger=card.querySelector('[data-orjn-qa-trigger]');
    const panel=card.querySelector('[data-orjn-qa-panel]');
    const direct=card.querySelector('[data-orjn-qa-direct]');
    if(direct&&!direct.closest('[data-orjn-qa]').querySelector('[data-orjn-qa-message]')){
      const message=document.createElement('p');message.className='orjn-card-qa__message';message.dataset.orjnQaMessage='';message.hidden=true;message.setAttribute('role','status');direct.closest('[data-orjn-qa]').append(message);
    }
    if(trigger&&panel&&!panel.dataset.archiveReady){
      panel.dataset.archiveReady='true';
      panel.querySelector('.orjn-card-qa__label').textContent='Select EU size · tap to add';
      panel.querySelector('[data-orjn-qa-message]').setAttribute('role','status');
      const close=document.createElement('button');close.type='button';close.className='orjn-card-qa__close';close.dataset.archiveClose='';close.setAttribute('aria-label','Close size choices');
      close.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg>';
      panel.querySelector('.orjn-card-qa__panel-head').append(close);
    }
  });
  root.querySelectorAll('[data-archive-filter-form]').forEach(form=>{
    if(form.dataset.archiveParamsReady)return;
    form.dataset.archiveParamsReady='true';
    for(const[name,value]of new URLSearchParams(location.search)){
      if(!/^(preview_theme_id|utm_.+|gclid|fbclid)$/.test(name))continue;
      const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.append(input);
    }
  });
}
archiveNativeSizes();
document.addEventListener('orjn:archive-color:render',e=>archiveNativeSizes(e.detail.root));
document.addEventListener('DOMContentLoaded',()=>archiveNativeSizes(),{once:true});
document.addEventListener('shopify:section:load',e=>archiveNativeSizes(e.target));
document.addEventListener('submit',e=>{
  if(e.target.matches?.('[data-archive-filter-form]'))e.target.querySelectorAll('input[type=number]').forEach(input=>{if(input.value==='')input.disabled=true;});
});
// Capture only this campaign's size buttons; the shared card still opens and positions its own popup.
document.addEventListener('click',async e=>{
  const trigger=e.target.closest?.('[data-orjn-qa-trigger]');
  if(trigger?.closest('.orjn-archive__normal-card')){
    e.preventDefault();e.stopImmediatePropagation();
    const quickAdd=trigger.closest('[data-orjn-qa]');
    if(quickAdd.classList.contains('is-archive-open')){archiveCloseQuickAdd(quickAdd,true);return;}
    document.querySelectorAll('.orjn-archive__normal-card [data-orjn-qa].is-archive-open').forEach(q=>archiveCloseQuickAdd(q));
    const panel=quickAdd.querySelector('[data-orjn-qa-panel]');
    quickAdd.classList.add('is-archive-open');quickAdd.closest('.product-card')?.classList.add('is-qa-active');
    panel.hidden=false;
    if(typeof panel.showPopover==='function'){panel.setAttribute('popover','manual');panel.showPopover();}
    trigger.setAttribute('aria-expanded','true');archivePlaceQuickAdd(quickAdd);return;
  }
  const close=e.target.closest?.('[data-archive-close]');
  if(close){e.preventDefault();e.stopImmediatePropagation();archiveCloseQuickAdd(close.closest('[data-orjn-qa]'),true);return;}
  document.querySelectorAll('.orjn-archive__normal-card [data-orjn-qa].is-archive-open').forEach(q=>{if(!q.contains(e.target))archiveCloseQuickAdd(q);});
  const button=e.target.closest?.('[data-orjn-qa-size],[data-orjn-qa-direct]');
  const card=button?.closest('.orjn-archive__normal-card');
  if(!card)return;
  e.preventDefault();e.stopImmediatePropagation();
  const quickAdd=button.closest('[data-orjn-qa]');
  if(quickAdd.dataset.archiveBusy)return;
  const variantId=button.dataset.variantId;
  const variant=card.querySelector('[data-archive-variants]').content.querySelector(`[data-variant-id="${variantId}"]`);
  if(!variant)return;
  const message=quickAdd.querySelector('[data-orjn-qa-message]');
  quickAdd.dataset.archiveBusy='true';
  const buttons=[...quickAdd.querySelectorAll('[data-orjn-qa-size],[data-orjn-qa-direct]')];
  buttons.forEach(b=>{b.disabled=true;});
  button.setAttribute('aria-busy','true');button.classList.add('is-loading');
  if(message){message.hidden=true;message.textContent='';message.setAttribute('role','status');}
  const body=new FormData();body.set('id',variantId);body.set('quantity','1');
  const sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
  if(sections.length)body.set('sections',sections.join(','));
  body.set('sections_url',location.pathname);
  const root=window.Shopify?.routes?.root||'/';
  try{
    const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body});
    const data=await response.json();
    if(!response.ok||data.status){const failure=new Error(typeof data.description==='string'?data.description:'This size could not be added. Choose another size.');failure.cartRejected=true;throw failure;}
    const price=card.querySelector('[data-archive-price]'),compare=card.querySelector('[data-archive-compare]');
    price.textContent=variant.dataset.price;
    compare.textContent=variant.dataset.compare;compare.hidden=!variant.dataset.compare;
    card.dataset.offerAvailable='true';card.dataset.offerDiscount=String(Boolean(variant.dataset.compare));
    const unavailable=card.querySelector('[data-archive-availability]');if(unavailable)unavailable.hidden=true;
    card.querySelector('[data-archive-price-prefix]').textContent='';
    card.querySelectorAll('[data-archive-link]').forEach(a=>{const url=new URL(a.href);url.searchParams.set('variant',variantId);a.href=url.pathname+url.search;});
    if(message){message.textContent=`EU ${variant.dataset.size} added. `;message.hidden=false;message.dataset.state='success';const link=document.createElement('a');link.href=`${root}cart`;link.textContent='View cart';message.append(link);}
    const events=await archiveEvents;
    if(events?.CartAddEvent)card.dispatchEvent(new events.CartAddEvent({},variantId,{source:'product-form-component',productId:card.dataset.productId,variantId,itemCount:1,sections:data.sections}));
    // Copy of Latest has auto-open disabled. Open its existing drawer for confirmation.
    const drawer=document.querySelector('cart-drawer-component');
    if(typeof drawer?.open==='function'){
      archiveCloseQuickAdd(quickAdd);
      drawer.open();
    }
  }catch(failure){
    if(message){
      message.hidden=false;message.dataset.state='error';message.setAttribute('role','alert');
      message.textContent=failure.cartRejected?failure.message:'We could not confirm the addition. Check your cart before trying again.';
      if(!failure.cartRejected){const link=document.createElement('a');link.href=`${root}cart`;link.textContent='View cart';message.append(link);}
    }
  }finally{
    delete quickAdd.dataset.archiveBusy;buttons.forEach(b=>{b.disabled=false;});
    button.removeAttribute('aria-busy');button.classList.remove('is-loading');
  }
},true);
document.addEventListener('keydown',e=>{
  if(e.key!=='Escape')return;
  const quickAdd=document.querySelector('.orjn-archive__normal-card [data-orjn-qa].is-archive-open');
  if(quickAdd){archiveCloseQuickAdd(quickAdd,true);e.preventDefault();}
});
window.addEventListener('resize',()=>document.querySelectorAll('.orjn-archive__normal-card [data-orjn-qa].is-archive-open').forEach(q=>archiveCloseQuickAdd(q)));


  } catch(e) { console.error(e); }
})();
})();
